module.exports = __webpack_public_path__ + "static/media/ck-home.d2f0130b.svg";